const auth = '-H "Authorization: Bearer $PAIGE_API_KEY"';

export const addWebhook = `curl https://v2.paige.app/v1/jobs/9e447cc1-0cb9-4364-9efb-a655da2efe5f/destinations ${auth} \\
  -H "Idempotency-Key: $(uuidgen)" \\
  -H "Content-Type: application/json" \\
  -d '{"kind": "webhook", "label": "AP system",
       "settings": {"url": "https://erp.example.com/paige/webhook", "secret": "a-long-random-secret-of-your-own"}}'

201 Created
{"id": "<destination id>", "kind": "webhook", "label": "AP system", "health": "idle",
 "settings": {"url": "https://erp.example.com/paige/webhook"}, "secretSet": true, ...}`;

// -d '' sends the empty body with its Content-Length, which a POST needs (411 without it).
export const testWebhook = `curl https://v2.paige.app/v1/jobs/9e447cc1-0cb9-4364-9efb-a655da2efe5f/destinations/<destination id>/test ${auth} \\
  -H "Idempotency-Key: $(uuidgen)" -d ''

{"ok": true, "detail": "Answered 200", "entries": null, "choices": null, "hostKeyFingerprint": null}`;

export const delivery = `POST /paige/webhook HTTP/1.1
Content-Type: application/json
User-Agent: Paige/2
Paige-Event: document.confirmed
Paige-Delivery: 8b0f3a526c1e4f7a9d2b0e4c5a6b7c8d
Paige-Signature: t=1791076374,v1=6ac8372bd58e36d6ff6cbd8b8bf954e3c67da83ebbafcc52f23348155cdb11d8

{
  "event": "document.confirmed",
  "delivery_id": "8b0f3a52-6c1e-4f7a-9d2b-0e4c5a6b7c8d",
  "attempt": 1,
  "job_id": "9e447cc1-0cb9-4364-9efb-a655da2efe5f",
  "document": { ...document.json: type, pages, fields, line_items, filed... },
  "package": {
    "json": "https://v2.paige.app/v1/documents/a185de74-c65f-4f84-8654-824aa67821d6/package/document.json",
    "pdf": "https://v2.paige.app/v1/documents/a185de74-c65f-4f84-8654-824aa67821d6/package/pages.pdf"
  }
}`;
